import { WebsiteHeaderPhotoSchema_PhotoDuoRight_v1_1_1 } from '@apps/guest/websiteHeader';

export const PHOTO_DUO_RIGHT_v1_1_1: WebsiteHeaderPhotoSchema_PhotoDuoRight_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoRight-v1_1_1.json',
  presentationLayout: 'photoDuoRight',
  photos: [],
};
